import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <div className="theme-toggle">
      <button 
        className={`theme-toggle-button ${isDarkMode ? 'dark' : 'light'}`}
        onClick={toggleTheme}
        aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
        title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
      >
        <div className="theme-toggle-slider">
          <span className="theme-toggle-icon sun">☀️</span>
          <span className="theme-toggle-icon moon">🌙</span>
        </div>
      </button>
    </div>
  );
};

export default ThemeToggle;